// (c) chaehongee. Confidential and proprietary.

import { useState, useEffect } from 'react'
import type { ReactElement } from 'react'
import styles from '../Backstage.module.css'
import spinners from 'cli-spinners'
import { parseToolNote } from '../utils/toolNames'

const SPINNER_FRAMES = spinners.dots.frames

interface ToolNoteProps {
    text: string
    count?: number
    active?: boolean
}

// A tool-progress step in the thread: a human action label ("Retouching") with
// the model riding along as quiet attribution ("· nanobanana"). Consecutive
// identical steps are collapsed upstream (ChatPage) and shown with a ×N count.
// When `active`, a spinner ticks to signal the step is still running.
export function ToolNote({ text, count = 1, active = false }: ToolNoteProps): ReactElement {
    const [frameIndex, setFrameIndex] = useState(0)

    useEffect(() => {
        if (!active) return
        const interval = setInterval(() => {
            setFrameIndex((prev) => (prev + 1) % SPINNER_FRAMES.length)
        }, spinners.dots.interval)
        return () => clearInterval(interval)
    }, [active])

    const { action, model } = parseToolNote(text)

    return (
        <div className={styles.msgRow}>
            <div className={styles.msgNote}>
                {action}
                {model && model !== action && (
                    <span className={styles.toolNoteModel}> · {model}</span>
                )}
                {count > 1 && <span className={styles.toolNoteModel}> ×{count}</span>}
                {active && <> {SPINNER_FRAMES[frameIndex]}</>}
            </div>
        </div>
    )
}
